export default __webpack_public_path__ + "static/media/time.2f5b1c8f.svg";